import styled from "styled-components";
import { designTokens } from '../../ui/foundation/DesignTokens';

export const EndChatModalContainer = styled.div`
  position: fixed;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
`;

export const EndChatModalStyled = styled.section`
  width: 50vw;
  max-width: 600px;
  background-color: white;
  padding: 32px;
  border-radius: ${designTokens.radius.xl};
  box-shadow: ${designTokens.shadows.xl};

  @media (max-width: 768px) {
    width: 90vw;
    padding: 24px;
  }
`;

export const Title = styled.h2`
  text-align: center;
  font-family: ${designTokens.fonts.heading};
  font-size: 1.25rem;
  font-weight: 700;
  color: ${designTokens.colors.gray[900]};
  margin-bottom: 32px;
`;

export const Section = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const SectionComment = styled.div`
  margin-bottom: 20px;
`;

export const SectionMiddle = styled.div`
  width: 50%;
`;

export const FormTitle = styled.h3`
  font-family: ${designTokens.fonts.heading};
  font-size: 0.9375rem;
  color: ${designTokens.colors.gray[600]};
  margin-bottom: 16px;
  font-weight: 600;
`;

export const StarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Star = styled.img`
  cursor: pointer;
  width: 36px;
  height: 36px;
  transition: transform 0.15s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const Input = styled.input`
  background: ${designTokens.colors.gray[50]};
  border-radius: ${designTokens.radius.md};
  border: 1px solid ${designTokens.colors.gray[200]};
  padding: 12px 16px;
  font-size: 0.9375rem;
  font-family: ${designTokens.fonts.body};
  color: ${designTokens.colors.gray[900]};
  width: 100%;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${designTokens.colors.primary[500]};
    box-shadow: 0 0 0 3px rgba(44, 95, 78, 0.1);
  }

  &::placeholder {
    color: ${designTokens.colors.gray[400]};
  }
`;

export const TextArea = styled.textarea`
  background: ${designTokens.colors.gray[50]};
  border-radius: ${designTokens.radius.md};
  border: 1px solid ${designTokens.colors.gray[200]};
  padding: 12px 16px;
  font-size: 0.9375rem;
  font-family: ${designTokens.fonts.body};
  color: ${designTokens.colors.gray[900]};
  width: 100%;
  min-height: 100px;
  resize: vertical;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${designTokens.colors.primary[500]};
    box-shadow: 0 0 0 3px rgba(44, 95, 78, 0.1);
  }

  &::placeholder {
    color: ${designTokens.colors.gray[400]};
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
`;

export const CheckContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CancelButton = styled.button`
  border: 2px solid ${designTokens.colors.error[500]};
  border-radius: ${designTokens.radius.lg};
  color: ${designTokens.colors.error[500]};
  font-family: ${designTokens.fonts.heading};
  font-weight: 700;
  font-size: 0.9375rem;
  padding: 12px 24px;
  background-color: transparent;
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${designTokens.colors.error[50]};
  }
`;

export const FinishButton = styled.button`
  border: none;
  border-radius: ${designTokens.radius.lg};
  background-color: ${designTokens.colors.primary[500]};
  color: white;
  font-family: ${designTokens.fonts.heading};
  font-weight: 700;
  font-size: 0.9375rem;
  padding: 14px 24px;
  flex: 1;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${designTokens.colors.primary[600]};
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(44, 95, 78, 0.2);
  }

  &:disabled {
    background-color: ${designTokens.colors.gray[300]};
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const CheckboxLabel = styled.label`
  display: block;
  position: relative;
  padding-left: 36px;
  margin-bottom: 12px;
  cursor: pointer;
  font-family: ${designTokens.fonts.body};
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: ${designTokens.colors.gray[900]};
  user-select: none;
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: ${(props) => (props.checked ? designTokens.colors.primary[500] : designTokens.colors.gray[200])};
  border-radius: ${designTokens.radius.sm};
  transition: all 0.15s ease;

  &:after {
    content: "";
    position: absolute;
    display: none;
    left: 8px;
    top: 4px;
    width: 6px;
    height: 11px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:checked ~ ${Checkmark}:after {
    display: block;
  }
`;

export const RadioContainer = styled.label`
  display: block;
  position: relative;
  padding-left: 36px;
  margin-bottom: 12px;
  cursor: pointer;
  font-family: ${designTokens.fonts.body};
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: ${designTokens.colors.gray[900]};
  user-select: none;
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;

  &:checked ~ ${Checkmark}:after {
    display: block;
  }
`;

export const RadioCheckmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background-color: ${(props) => (props.checked ? designTokens.colors.primary[500] : designTokens.colors.gray[200])};
  transition: all 0.15s ease;

  &:after {
    content: "";
    position: absolute;
    display: ${(props) => (props.checked ? "block" : "none")};
    top: 8px;
    left: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`;

export const RadioWrapper = styled.div`
  display: flex;
  gap: 24px;
`;
